<template>
  <sx-header />
  <slot />
</template>
